import "./Loading.scss";

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading-icon">
        <h1>Loading...</h1>
      </div>
    </div>
  );
};

export default Loading;
